import React from 'react';

import autoBind from 'react-autobind';
import { If } from 'react-if'

import Localization from "../Localization.jsx"

import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';

class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasLabel: true,
      showUsername: false,
    };
    autoBind(this);

    if (this.props.hasLabel != null) {
      this.state.hasLabel = this.props.hasLabel;
    }
    if (this.props.showUsername != null) {
      this.state.showUsername = this.props.showUsername;
    }
  }

  userOptionChanged(e) {
    if (this.props.parent.userOptionChanged) {
      this.props.parent.userOptionChanged(e);
    }
  }

  render() {
    return (
      <FormControl style={{ width: '100%' , padding: '0px'}} variant="outlined">
      <If condition={this.state.hasLabel}>
        <InputLabel id="user-list-select">
          {Localization.strings.USER_LIST}
        </InputLabel>
      </If>
      <Select style={{ padding: '0px'}}
        labelId="user-list-select"
        value={this.props.userOption}
        onChange={this.userOptionChanged}
        label={this.state.hasLabel ? Localization.strings.USER_LIST : null} 
        SelectDisplayProps={{
          style: { padding: '10px', margin:'5px' }
        }}
        MenuProps={{ 
          PaperProps: { 
            style: { maxHeight: '300px' } 
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null, 
        }} 
      >
        <MenuItem key={-1} value={-1}>{Localization.strings.ALL_USERS}</MenuItem>
        <If condition={this.props.userList.length == 0}>
          <MenuItem value={0}>No User</MenuItem>
        </If>
        {this.props.userList.map( (row, i) => {
          return (
            <MenuItem key={i} value={i}>{(this.state.showUsername? row['username'] : row['display_name'])}</MenuItem>
          );
        })}
      </Select>
    </FormControl>

      

    )
  }
}

export default UserList;
